import { confirmationDialogReducer } from 'src/app/shared/reducers/confirmation-dialog.reducers';
import { statesReducer } from 'src/app/shared/reducers/states.reducers';
import { jobFulfillmentTypeReducer } from './job-fulfillment-type.reducers';
import { jobQualificationsReducer } from '../components/job-qualifications/reducers/job-qualifications.reducers';

export const sharedReducers = {
    confirmationDialog: confirmationDialogReducer,
    states: statesReducer,
    jobFulfillmentTypes: jobFulfillmentTypeReducer,
    jobQualifications: jobQualificationsReducer
};
